(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["short-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('short-description')) {
    customElements.define(
      'short-description',
      class ShortDescription extends HTMLElement {
        connectedCallback() {
          this.link = this.querySelector('.short-description__link');
          if (!this.link || this.link.dataset.bound === 'true') return;

          this.link.dataset.bound = 'true';
          this.link.addEventListener('click', () => {
            this.setExpanded(this.dataset.expanded !== 'true');
          });
        }

        setExpanded(expanded) {
          this.dataset.expanded = String(expanded);
          this.link.setAttribute('aria-expanded', String(expanded));

          const short = this.querySelector('.short-description__text--short');
          const full = this.querySelector('.short-description__text--full');
          const labels = this.querySelectorAll('.short-description__link-label');

          if (short) short.toggleAttribute('hidden', expanded);
          if (full) full.toggleAttribute('hidden', !expanded);
          if (labels[0]) labels[0].toggleAttribute('hidden', expanded);
          if (labels[1]) labels[1].toggleAttribute('hidden', !expanded);

          if (!expanded) requestAnimationFrame(() => this.scrollBackIntoView());
        }

        /* Collapsing a long text leaves the reader stranded below where the
           block now ends, so bring its top back into view — but only when the
           page has actually scrolled past the start of the block */
        scrollBackIntoView() {
          const scroller = this.scrollContainer();
          const isWindow = scroller === window;
          const current = isWindow ? window.scrollY : scroller.scrollTop;
          const base = isWindow ? 0 : this.layoutTop(scroller);
          const target = Math.max(this.layoutTop(this) - base - this.headerOffset() - 8, 0);

          if (target >= current) return;

          /* 'instant', not 'auto': 'auto' defers to CSS, and both .page-wrapper
             and html are declared scroll-behavior: smooth by the theme */
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          scroller.scrollTo({ top: target, behavior: reduceMotion ? 'instant' : 'smooth' });
        }

        /* Horizon hands scrolling to .page-wrapper from 990px up (html and
           body are overflow: hidden there), so the window is not always what
           scrolls — find whatever actually does */
        scrollContainer() {
          let node = this.parentElement;

          while (node && node !== document.body && node !== document.documentElement) {
            const overflow = getComputedStyle(node).overflowY;

            if ((overflow === 'auto' || overflow === 'scroll') && node.scrollHeight > node.clientHeight + 1) {
              return node;
            }

            node = node.parentElement;
          }

          return window;
        }

        /* Layout position, walked through offsetParent, rather than
           getBoundingClientRect(): the product details column is position:
           sticky on desktop, and while it is pinned its children report a
           viewport rect that does not move with the scroll — which makes any
           rect-based target wrong. Sticky shifts painting only, so offsetTop
           still reports the unpinned position. */
        layoutTop(node) {
          let y = 0;

          while (node) {
            y += node.offsetTop;
            node = node.offsetParent;
          }

          return y;
        }

        headerOffset() {
          const header = document.querySelector('header-component, .header-wrapper, .header');
          if (!header) return 0;

          const position = getComputedStyle(header).position;
          if (position !== 'sticky' && position !== 'fixed') return 0;

          return header.getBoundingClientRect().height;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
